import { Component, input, ChangeDetectionStrategy } from '@angular/core';

export type ButtonTypes = 'default' | 'gradient';
export type ButtonColor = 'default' | 'neutral' | 'success' | 'warning' | 'error';
export type ButtonDensity = 'default' | 'compact';

/**
 * The app's standard button. Two styles: `default` — a frosted-glass
 * control matching andor-square-icon-btn's surface language — and
 * `gradient` — the flashy CTA. `color` tints either style with the theme
 * variant colors (default = accent, neutral = gray), mirroring andor-notice. `density`
 * switches between the full-height button and a half-height `compact` one
 * for tight surfaces (inline notices etc.).
 */
@Component({
  selector: 'andor-button',
  standalone: true,
  templateUrl: './button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './button.scss',
})
export class Button {
  disabled = input(false);
  type = input<ButtonTypes>('default');
  color = input<ButtonColor>('default');
  density = input<ButtonDensity>('default');
}
